import styled, { createGlobalStyle } from 'styled-components'
import {
	backgroundOrange,
	darkOrange,
	orange,
	blackOrange,
	mutedGrey,
	lightGrey,
	white,
	warmTint,
	border1,
	border2,
} from '@/theme/colors'
import { shadows, radii, motion } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'

export const Wrapper = styled.div`
    width: 100%;

    .react-datepicker-wrapper {
        width: 100%;
    }

    .react-datepicker__input-container input {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid ${border2};
        border-radius: ${radii.small};
        font-size: ${fontSizes.small};
        background: ${white};
        color: ${blackOrange};
        transition: border-color ${motion.base}, box-shadow ${motion.base};
        cursor: pointer;

        &:focus {
            outline: none;
            border-color: ${orange};
            box-shadow: ${shadows.focus};
        }

        &::placeholder {
            color: ${mutedGrey};
        }
    }
`

export const DatePickerGlobalStyles = createGlobalStyle`
    .react-datepicker {
        font-family: inherit;
        border: 1px solid ${border1};
        border-radius: ${radii.inner};
        box-shadow: ${shadows.overlay};
        overflow: hidden;
    }

    .react-datepicker__header {
        background: ${backgroundOrange};
        border-bottom: 1px solid ${warmTint};
        padding-top: 12px;
    }

    .react-datepicker__current-month,
    .react-datepicker-time__header {
        color: ${blackOrange};
        font-weight: 700;
        font-size: ${fontSizes.small};
    }

    .react-datepicker__day-name {
        color: ${darkOrange};
        font-weight: 500;
    }

    .react-datepicker__day {
        color: ${blackOrange};
        border-radius: ${radii.small};

        &:hover {
            background: ${backgroundOrange};
        }
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--keyboard-selected {
        background: ${orange};
        color: ${white};

        &:hover {
            background: ${darkOrange};
        }
    }

    .react-datepicker__day--today {
        font-weight: 700;
        color: ${darkOrange};
    }

    .react-datepicker__day--disabled {
        color: ${lightGrey};
    }

    .react-datepicker__navigation-icon::before {
        border-color: ${darkOrange};
    }

    .react-datepicker__time-container {
        border-left: 1px solid ${warmTint};
    }

    .react-datepicker__time-list-item--selected {
        background: ${orange} !important;
        color: ${white} !important;
    }

    .react-datepicker__time-list-item:hover {
        background: ${backgroundOrange} !important;
    }

    .react-datepicker__triangle {
        display: none;
    }
`
